import React, { useEffect, useRef, useState } from "react";
import DialogWrap, { DialogWrapLogin, DialogWrapMedium } from "../../../controls/components/dialogWrap/DialogWrap";
import { ActiveType } from "../../../../models/Login";
import {
	FomrmLoginInput,
	FomrmLoginInputPhone,
	FomrmLoginInputPhoneNumberInner,
	SeledctApp,
} from "../../LoginUser/styled/LoginStyles";
import {
	OrderInput,
	OrderInputPhoneNumberWrap,
	OrderInputWrap,
	OrderPageInfomationTime,
	OrderPageInfomationTimeTitle,
	OrderPageInfomationTimeWrap,
} from "../../Order/styled/OrderStyle";
import DateRangeInput, { TimeRangeInput } from "../../../controls/components/dateRangeInput/DateRangeInputOrder";
import { CustomDropdown, SelectApp } from "../../LoginUser/component/FormCreateOne";
import { PHONE_COUNTRY_CODE } from "../../LoginUser/hook/phoneCountryCode";
import {
	InputOrderAdminTitle,
	UserFormServiceButtonClose,
	UserFormServiceButtonCreated,
} from "../../MyBooking/styled/DesStyled";
import useAddPartnerAdmin from "../hook/AddPartnerAdmin";
import useUpdatePartnerAdmin from "../hook/UpdatePartnerAdmin";
import usePartnerDetail from "../hook/useGetUserDetail";
import PartnerDestinationSelect, { PartnerDestinationSelectHandle } from "./PartnerDestinationSelect";
import { AdminFilterEmailPartner } from "../hook/FilterEmailPartner";
import { buildPartnerPricingPreview, validatePartnerPriceComposition } from "./partnerPricingPreview";
import { formatMoneyInputDisplay, formatValueToDisplay, parseMoneyToNumber, sanitizeMoneyInput } from "./moneyInput";
import {
	type ClosureDateRangeRow,
	parseClosureConfigFromApi,
	buildClosureExceptionConfigForApi,
} from "../utils/partnerClosureConfigHelpers";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import {
	putAdminPartnerContractViolationCount,
	uploadBagProductImage,
	uploadAvatarMutiImage,
} from "../../../../services/PartnerService";
import { NearbyAttractionItem } from "../../../../models/Partner";
import { resolveAssetUrl } from "../../../../utils/assetUrl";
import { getSystemConfig } from "../../../../services/SystemConfigService";
import { push } from "@whalelo/audit-client";
import { docCheDoGon, laStation } from "./cheDoGon";
import TaiKhoanChuoiForm from "./TaiKhoanChuoiForm";
import { PutChainAccountAdmin } from "../../../../services/PartnerService";
import { ListUserSearch } from "../../../../services/UserService";
import BusinessLicenceReview from "./BusinessLicenceReview";
import TransferStationOwner from "./TransferStationOwner";
import TaxLegalReview from "./TaxLegalReview";
import { workTimeForForm } from "../../../../utils/stationHours";

export type NearbyAttractionDraft = Omit<NearbyAttractionItem, "image"> & { image: string | File };

/**
 * Pad hotlines lên đúng 4 slot và auto-fill slot[3] (Station support) bằng `defaultStationPhone`
 * khi slot đang rỗng. Nếu defaultStationPhone rỗng → giữ nguyên rỗng (admin tự gõ).
 * Quy ước slot: [0] Facility hotline 1, [1] Facility hotline 2, [2] Customer support, [3] Station support.
 */
const normalizeHotlineValues = (hotlines?: string[], defaultStationPhone?: string) => {
	const nextHotlines = Array.isArray(hotlines) ? hotlines.slice(0, 4) : [];
	while (nextHotlines.length < 4) {
		nextHotlines.push("");
	}
	const trimmedDefault = String(defaultStationPhone ?? "").trim();
	if (trimmedDefault && !String(nextHotlines[3] || "").trim()) {
		nextHotlines[3] = trimmedDefault;
	}
	return nextHotlines;
};

const resolveAdminWorkTime = (userDetail: any) => {
	const from = String(userDetail?.workTime?.[0]?.hour?.from || "").trim();
	const to = String(userDetail?.workTime?.[0]?.hour?.to || "").trim();

	if (from && to) {
		// Chữ cũ kiểu "8 AM", "6.30 am", "24/7" ⇒ "HH:MM" để hiện đúng trong ô chọn giờ (26/10/2026).
		const norm = workTimeForForm(from, to);
		return norm.from && norm.to ? norm : { from, to };
	}

	const note = String(userDetail?.note || "");
	if (note.includes("Opening hours: Open 24 hours")) {
		return {
			from: "00:00",
			to: "23:59",
		};
	}

	return {
		from: "",
		to: "",
	};
};

export default function DialogUpdatePartnerAdmin(props: {
	openDialog: boolean;
	setOpenDialog: (value: boolean) => void;
	partnerId: string;
	reload: () => void;
}) {
	const { updatePartnerAd } = useUpdatePartnerAdmin({ id: props.partnerId, reload: props.reload });
	const { userDetail, reloadDetail } = usePartnerDetail({ id: props.partnerId, openDialog: props.openDialog });
	const { openAlertDialog } = useAlertDialog();
	const [violationSaving, setViolationSaving] = useState(false);

	const [name, setName] = useState("");
	const [address, setAddress] = useState("");
	const [addressText, setAddressText] = useState("");
	const [note, setNote] = useState("");
	const [lat, setLat] = useState("");
	const [long, setLong] = useState("");
	const [displayName, setDisplayName] = useState("");
	const [displayAddress, setDisplayAddress] = useState("");

	const [toWork, setToWork] = useState("");
	const [fromWork, setFromWork] = useState("");
	const [price, setPrice] = useState("0");
	const [insurancePrice, setInsurancePrice] = useState("0");
	const [reviewScore, setReviewScore] = useState("");
	const [reviewQuantity, setReviewQuantity] = useState("");
	const [locationId, setLocationId] = useState("");
	const [hotline, setHotline] = useState<string[]>(normalizeHotlineValues());
	/**
	 * Số Station support mặc định lấy từ SystemConfig (admin cấu hình ở trang System Config).
	 * Rỗng = chưa load xong hoặc admin chủ ý không có default → dialog sẽ không auto-fill.
	 */
	const [defaultStationSupportPhone, setDefaultStationSupportPhone] = useState<string>("");
	const [emailPartner, setEmailPartner] = useState("");
	const [stationEmail, setStationEmail] = useState("");

	const [stationCom, setStationCom] = useState("");
	const [minimumPayout, setMinimumPayout] = useState("");
	const [maximumPayout, setMaximumPayout] = useState("");
	const [pubRate, setPubRate] = useState("");
	const [rateLimitMax, setRateLimitMax] = useState("");
	const [selectedCountryCode, setSelectedCountryCode] = useState(PHONE_COUNTRY_CODE[0].dial_code);
	const [countryRatesRows, setCountryRatesRows] = useState<any[]>([]);
	const [selectedLocation, setSelectedLocation] = useState<any | null>(null);
	const [localCurrencyCode, setLocalCurrencyCode] = useState("");
	const lastAutoPubRateRef = useRef("");
	const destinationSelectRef = useRef<PartnerDestinationSelectHandle | null>(null);

	const [closureDateRanges, setClosureDateRanges] = useState<ClosureDateRangeRow[]>([]);
	const [permanentClosureEnabled, setPermanentClosureEnabled] = useState(false);
	const [permanentEffectiveFrom, setPermanentEffectiveFrom] = useState("");
	const [closureConfigError, setClosureConfigError] = useState("");
	const [feeSmall, setFeeSmall] = useState<string>("");
	const [feeMedium, setFeeMedium] = useState<string>("");
	const [feeLarge, setFeeLarge] = useState<string>("");
	const [imageSmall, setImageSmall] = useState<string | null>(null);
	const [imageMedium, setImageMedium] = useState<string | null>(null);
	const [imageLarge, setImageLarge] = useState<string | null>(null);

	// Station page content
	const [stationShowMeetTab, setStationShowMeetTab] = useState(false);
	const [stationShowNearbyTab, setStationShowNearbyTab] = useState(false);
	const [mapImage, setMapImage] = useState<string>("");
	const [meetStationSubtitle, setMeetStationSubtitle] = useState<string>("");
	const [nearbyAttractionsContent, setNearbyAttractionsContent] = useState<NearbyAttractionDraft[]>([]);

	const pricingPreview = React.useMemo(
		() =>
			buildPartnerPricingPreview({
				countryRatesRows,
				address,
				addressText,
				selectedCountryCode,
				destinationCountry: selectedLocation?.country,
				localCurrencyCode,
				manualStationCom: stationCom,
				manualMinimumPayout: minimumPayout,
				manualPubRate: pubRate,
			}),
		[
			address,
			addressText,
			countryRatesRows,
			localCurrencyCode,
			minimumPayout,
			pubRate,
			selectedCountryCode,
			selectedLocation?.country,
			stationCom,
		]
	);

	const resolvedPubRateDisplay = React.useMemo(() => {
		if (pubRate) return pubRate;
		return formatValueToDisplay(pricingPreview.appliedPubRate);
	}, [pricingPreview.appliedPubRate, pubRate]);

	const priceComposition = React.useMemo(
		() => validatePartnerPriceComposition(price, insurancePrice, resolvedPubRateDisplay),
		[insurancePrice, price, resolvedPubRateDisplay]
	);

	const violationCount = Math.min(
		3,
		Math.max(
			0,
			Math.trunc(Number((userDetail as { contractViolationCount?: number | null })?.contractViolationCount) || 0)
		)
	);

	const persistContractViolationCount = async (next: number) => {
		const clamped = Math.min(3, Math.max(0, Math.trunc(next)));
		setViolationSaving(true);
		try {
			await putAdminPartnerContractViolationCount(props.partnerId, clamped);
			reloadDetail();
			props.reload?.();
			openAlertDialog?.(AlertType.Success, "Đã cập nhật vi phạm hợp đồng.", () => {});
		} catch (err: any) {
			openAlertDialog?.(AlertType.Fail, err?.response?.data?.message || err?.message || "Không lưu được.");
		} finally {
			setViolationSaving(false);
		}
	};

	// 28/10/2026 (Quân): tài khoản chủ chuỗi thuần không phải địa điểm ⇒ không có form điểm lẻ, không kiểm giá.
	const laTaiKhoanChuoi = Boolean(userDetail) && !laStation(userDetail);
	const [loiTaiKhoanChuoi, setLoiTaiKhoanChuoi] = useState("");
	const priceCompositionError =
		!laTaiKhoanChuoi && resolvedPubRateDisplay && !priceComposition.isValid ? "Base price + insurance price must equal the public rate." : "";

	useEffect(() => {
		if (props.openDialog) {
			import("../../../../services/CountryRatesService").then(({ getCountryRates }) => {
				getCountryRates()
					.then((data) => setCountryRatesRows(data?.rows || []))
					.catch(() => setCountryRatesRows([]));
			});
		}
	}, [props.openDialog]);

	useEffect(() => {
		if (!props.openDialog) return;
		let mounted = true;
		getSystemConfig()
			.then((cfg) => {
				if (!mounted) return;
				const def = String(cfg.stationSupportPhone || "").trim();
				setDefaultStationSupportPhone(def);
				if (!def) return;
				setHotline((prev) => {
					const next = Array.isArray(prev) ? prev.slice(0, 4) : [];
					while (next.length < 4) next.push("");
					if (String(next[3] || "").trim()) return prev;
					next[3] = def;
					return next;
				});
			})
			.catch(() => {});
		return () => {
			mounted = false;
		};
	}, [props.openDialog]);

	useEffect(() => {
		if (props.openDialog && userDetail) {
			const resolvedWorkTime = resolveAdminWorkTime(userDetail);
			setName(userDetail.name || "");
			setAddress(userDetail.address || "");
			setAddressText(userDetail.addressText || "");
			setNote(userDetail.note || "");
			setLat((userDetail.lat || 0).toString());
			setLong((userDetail.long || 0).toString());
			setDisplayName(userDetail.displayName || "");
			setDisplayAddress(userDetail.displayAddress || "");

			setToWork(resolvedWorkTime.to);
			setFromWork(resolvedWorkTime.from);
			setPrice(formatValueToDisplay(userDetail.fee));
			setReviewScore((userDetail.rateReview || 0).toString());
			setReviewQuantity((userDetail.reviewCount || "0").toString());
			setLocationId(userDetail.destinationId || "");
			setInsurancePrice(formatValueToDisplay(userDetail.insuranceFee));
			setHotline(normalizeHotlineValues(userDetail.hotlineNumber, defaultStationSupportPhone));
			setEmailPartner(userDetail.store?.storeOwnerUser?.id || "");
			setStationEmail(userDetail.user?.email || "");
			setStationCom(formatValueToDisplay(userDetail.stationCom));
			setMinimumPayout(formatValueToDisplay(userDetail.minimumPayout));
			setMaximumPayout(formatValueToDisplay(userDetail.maximumPayout));
			setPubRate(formatValueToDisplay(userDetail.pubRate));
			lastAutoPubRateRef.current = "";
			setRateLimitMax(formatValueToDisplay(userDetail.rateLimitMax));
			setFeeSmall(formatValueToDisplay((userDetail as any).feeSmall));
			setFeeMedium(formatValueToDisplay((userDetail as any).feeMedium));
			setFeeLarge(formatValueToDisplay((userDetail as any).feeLarge));
			setImageSmall((userDetail as any).imageSmall || null);
			setImageMedium((userDetail as any).imageMedium || null);
			setImageLarge((userDetail as any).imageLarge || null);
			setSelectedLocation(userDetail.destination || null);

			// Station page content
			setStationShowMeetTab(userDetail.stationShowMeetTab ?? false);
			setStationShowNearbyTab(userDetail.stationShowNearbyTab ?? false);
			setMapImage((userDetail as any).mapImage || "");
			setMeetStationSubtitle(userDetail.meetStationSubtitle || "");
			setNearbyAttractionsContent((userDetail as any).nearbyAttractionsContent || []);
			setLocalCurrencyCode(userDetail.localCurrencyCode || "");
			if (userDetail.phonePrefix) {
				setSelectedCountryCode(userDetail.phonePrefix);
			}

			const parsed = parseClosureConfigFromApi((userDetail as any).closureExceptionConfig);
			setClosureDateRanges(parsed.ranges.length ? parsed.ranges : []);
			setPermanentClosureEnabled(parsed.permanentEnabled);
			setPermanentEffectiveFrom(parsed.permanentFrom);
			setClosureConfigError("");
		}
	}, [userDetail, props.openDialog]);

	useEffect(() => {
		if (!props.openDialog) return;

		const autoPubRate = formatValueToDisplay(pricingPreview.estPubRate);
		const currentValue = pubRate || "";
		const lastAutoValue = lastAutoPubRateRef.current;

		if (!autoPubRate) {
			if (currentValue && currentValue === lastAutoValue) {
				setPubRate("");
			}
			lastAutoPubRateRef.current = "";
			return;
		}

		// Chỉ auto-fill khi user CHƯA động vào field (currentValue khớp với giá trị
		// auto đã apply trước đó). Nếu user chủ ý clear (currentValue="" trong khi
		// lastAutoValue != ""), KHÔNG được fill lại — save sẽ tự fallback về default
		// qua resolvedPubRateDisplay.
		const shouldApplyAuto = currentValue === lastAutoValue;

		if (shouldApplyAuto && currentValue !== autoPubRate) {
			lastAutoPubRateRef.current = autoPubRate;
			setPubRate(autoPubRate);
			return;
		}

		if (shouldApplyAuto) {
			lastAutoPubRateRef.current = autoPubRate;
		}
	}, [pricingPreview.estPubRate, props.openDialog, pubRate]);

	const luuTaiKhoanChuoi = async () => {
		setLoiTaiKhoanChuoi("");
		const email = stationEmail.trim();
		if (!name.trim()) return setLoiTaiKhoanChuoi("Enter the chain account name.");
		if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return setLoiTaiKhoanChuoi("Enter a valid sign-in email.");
		// Một email một vai: backend gặp email của user khác sẽ gắn tài khoản chuỗi sang user đó ⇒ chặn ở đây.
		if (email.toLowerCase() !== String(userDetail?.user?.email || "").trim().toLowerCase()) {
			try {
				const ds: any[] = (await ListUserSearch(encodeURIComponent(email))) || [];
				if (ds.some((u) => String(u?.email || "").trim().toLowerCase() === email.toLowerCase())) {
					return setLoiTaiKhoanChuoi("This email already has an account. A chain owner needs its own email.");
				}
			} catch (e) {
				return setLoiTaiKhoanChuoi("Could not check the email. Try again.");
			}
		}
		try {
			await PutChainAccountAdmin(props.partnerId, { name: name.trim(), note, email });
			props.setOpenDialog(false);
			openAlertDialog?.(AlertType.Success, "Update successfully!", () => props.reload?.());
		} catch (err: any) {
			setLoiTaiKhoanChuoi(err?.response?.data?.message || err?.message || "Could not save.");
		}
	};

	const handleSave = async () => {
		if (laTaiKhoanChuoi) return luuTaiKhoanChuoi();
		if (priceCompositionError) {
			return;
		}

		push({
			app: "admin",
			category: "ui_action",
			action: "partner.update",
			occurred_at: new Date().toISOString(),
			severity: 2,
			summary: `Admin updating station ${props.partnerId}`,
			meta: { partner_id: props.partnerId },
		});

		setClosureConfigError("");
		const closureBuilt = buildClosureExceptionConfigForApi(
			closureDateRanges,
			permanentClosureEnabled,
			permanentEffectiveFrom
		);
		if (!closureBuilt.ok) {
			setClosureConfigError(closureBuilt.message);
			return;
		}

		let finalLocationId = locationId;
		try {
			const ensured = await destinationSelectRef.current?.ensureMissingDestination?.();
			if (typeof ensured === "string" && ensured.length > 0) {
				finalLocationId = ensured;
			}
		} catch (e) {
			console.error(e);
		}

		// Convert File images → URLs before saving
		const resolvedAttractions: NearbyAttractionItem[] = await Promise.all(
			nearbyAttractionsContent.map(async (item) => {
				if (item.image instanceof File) {
					const results = await uploadAvatarMutiImage([item.image]);
					const url = results?.[0]?.url || results?.[0]?.path || "";
					return { ...item, image: url };
				}
				return item as NearbyAttractionItem;
			})
		);

		const isSuccess = await updatePartnerAd(
			name,
			address,
			addressText,
			note,
			lat,
			long,
			displayName,
			displayAddress,
			toWork,
			fromWork,
			price,
			insurancePrice,
			reviewScore,
			reviewQuantity,
			finalLocationId,
			hotline,
			emailPartner,
			stationEmail,
			stationCom,
			minimumPayout,
			maximumPayout,
			resolvedPubRateDisplay,
			rateLimitMax,
			closureBuilt.value,
			parseMoneyToNumber(feeSmall),
			parseMoneyToNumber(feeMedium),
			parseMoneyToNumber(feeLarge),
			imageSmall,
			imageMedium,
			imageLarge,
			mapImage || null,
			resolvedAttractions,
			stationShowMeetTab,
			stationShowNearbyTab,
			meetStationSubtitle || null
		);
		if (isSuccess) {
			props.setOpenDialog(false);
		}
	};
	return (
		<DialogWrapMedium
			login={true}
			open={props.openDialog}
			onClose={() => {
				props.setOpenDialog(false);
			}}
			title="Edit Station"
			actions={
				<>
					<UserFormServiceButtonClose onClick={() => props.setOpenDialog(false)}>
						Cancel
					</UserFormServiceButtonClose>
					<UserFormServiceButtonCreated
						disabled={Boolean(priceCompositionError)}
						onClick={handleSave}>
						Save
					</UserFormServiceButtonCreated>
				</>
			}>
			{/* 09/10/2026 (Quân): duyệt giấy phép kinh doanh — chưa duyệt thì trạm không rút được tiền. */}
			<BusinessLicenceReview
				partnerId={props.partnerId}
				open={props.openDialog}
				taiKhoanChuoi={laTaiKhoanChuoi}
			/>
			{/* 14/10/2026 (Quân): chuyển chủ trạm — chỉ super admin thấy (máy chủ gác). */}
			{/* Chủ chuỗi thuần: chuyển chủ chưa hỗ trợ cho chuỗi; đổi email đăng nhập ở form bên dưới. */}
			{laTaiKhoanChuoi ? <></> : (
			<TransferStationOwner
				partnerId={props.partnerId}
				open={props.openDialog}
				// Ô "Station email" của form đang giữ email chủ CŨ — không đồng bộ thì bấm Save
				// sẽ gắn trạm ngược lại cho tài khoản cũ (partnerUpdateService relink theo email).
				onTransferred={(newOwnerEmail) => setStationEmail(newOwnerEmail)}
			/>
			)}
			{/* 14/10/2026 (Quân): xem + duyệt thông tin thuế trạm VN (trạm chưa khai thì khối tự ẩn). */}
			<TaxLegalReview
				partnerId={props.partnerId}
				open={props.openDialog}
			/>
						{/* Vi phạm hợp đồng: 0/302 station từng ghi nhận (đo prod 28/08) và Quân chốt
			    đưa việc này sang Workspace — nơi có hồ sơ, ticket, bằng chứng đi kèm.
			    Ẩn ở bản gọn; tắt công tắc là khối cũ hiện lại nguyên vẹn. */}
			<div
				style={{
					display: docCheDoGon() || laTaiKhoanChuoi ? "none" : undefined,
					background: "#FFF7ED",
					border: "1px solid #FDBA74",
					borderRadius: 10,
					padding: "14px 16px",
					marginBottom: 16,
				}}>
				<div style={{ fontWeight: 700, fontSize: 14, marginBottom: 10, color: "#9A3412" }}>
					Vi phạm hợp đồng (tối đa 3 lần)
				</div>
				<p style={{ margin: "0 0 12px", fontSize: 12.5, color: "#78350F", lineHeight: 1.45 }}>
					Mức hiện tại: <strong>{violationCount === 0 ? "Chưa ghi nhận" : `Lần ${violationCount}`}</strong>
				</p>
				<div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
					<button
						type="button"
						disabled={violationSaving || violationCount >= 3}
						onClick={() => persistContractViolationCount(violationCount + 1)}
						style={{
							padding: "6px 12px",
							borderRadius: 6,
							border: "1px solid #EA580C",
							background: "#FFF7ED",
							color: "#9A3412",
							fontSize: 12,
							fontWeight: 600,
							cursor: violationSaving || violationCount >= 3 ? "not-allowed" : "pointer",
						}}>
						+ Ghi nhận thêm 1 lần
					</button>
					<button
						type="button"
						disabled={violationSaving || violationCount === 0}
						onClick={() => persistContractViolationCount(0)}
						style={{
							padding: "6px 12px",
							borderRadius: 6,
							border: "1px solid #D6D3D1",
							background: "#fff",
							color: "#57534E",
							fontSize: 12,
							fontWeight: 600,
							cursor: violationSaving || violationCount === 0 ? "not-allowed" : "pointer",
						}}>
						Đặt lại về 0
					</button>
					<label
						style={{
							display: "inline-flex",
							alignItems: "center",
							gap: 6,
							fontSize: 12,
							color: "#44403C",
						}}>
						<span>Set level:</span>
						<select
							value={violationCount}
							disabled={violationSaving}
							onChange={(e) => persistContractViolationCount(Number(e.target.value))}
							style={{ padding: "4px 8px", borderRadius: 4, fontSize: 12 }}>
							<option value={0}>0 — no violation</option>
							<option value={1}>Level 1</option>
							<option value={2}>Level 2</option>
							<option value={3}>Level 3</option>
						</select>
					</label>
					{violationSaving ? <span style={{ fontSize: 12, color: "#78716C" }}>Saving…</span> : null}
				</div>
			</div>
			{laTaiKhoanChuoi ? (
				<TaiKhoanChuoiForm
					name={name}
					setName={setName}
					email={stationEmail}
					setEmail={setStationEmail}
					note={note}
					setNote={setNote}
					loi={loiTaiKhoanChuoi}
				/>
			) : (
			<InputPartnerAdmin
				name={name}
				setName={setName}
				address={address}
				setAddress={setAddress}
				addressText={addressText}
				setAddressText={setAddressText}
				note={note}
				setNote={setNote}
				lat={lat}
				setLat={setLat}
				long={long}
				setLong={setLong}
				displayName={displayName}
				setDisplayName={setDisplayName}
				displayAddress={displayAddress}
				setDisplayAddress={setDisplayAddress}
				toWork={toWork}
				setToWork={setToWork}
				fromWork={fromWork}
				setFromWork={setFromWork}
				price={price}
				setPrice={setPrice}
				reviewScore={reviewScore}
				setReviewScore={setReviewScore}
				reviewQuantity={reviewQuantity}
				setReviewQuantity={setReviewQuantity}
				locationId={locationId}
				setLocationId={setLocationId}
				insurancePrice={insurancePrice}
				setInsurancePrice={setInsurancePrice}
				hotline={hotline}
				setHotline={setHotline}
				emailPartner={emailPartner}
				setEmailPartner={setEmailPartner}
				stationEmail={stationEmail}
				setStationEmail={setStationEmail}
				stationCom={stationCom}
				setStationCom={setStationCom}
				minimumPayout={minimumPayout}
				setMinimumPayout={setMinimumPayout}
				maximumPayout={maximumPayout}
				setMaximumPayout={setMaximumPayout}
				pubRate={pubRate}
				setPubRate={setPubRate}
				rateLimitMax={rateLimitMax}
				setRateLimitMax={setRateLimitMax}
				selectedCountryCode={selectedCountryCode}
				countryRatesRows={countryRatesRows}
				selectedLocation={selectedLocation}
				setSelectedLocation={setSelectedLocation}
				localCurrencyCode={localCurrencyCode}
				priceCompositionError={priceCompositionError}
				estimatedPubRate={pricingPreview.estPubRate}
				destinationSelectRef={destinationSelectRef}
				closureDateRanges={closureDateRanges}
				setClosureDateRanges={setClosureDateRanges}
				permanentClosureEnabled={permanentClosureEnabled}
				setPermanentClosureEnabled={setPermanentClosureEnabled}
				permanentEffectiveFrom={permanentEffectiveFrom}
				setPermanentEffectiveFrom={setPermanentEffectiveFrom}
				closureConfigError={closureConfigError}
				stationTimezoneHint={
					String(
						(userDetail as any)?.timezoneId || (userDetail as any)?.destination?.timezone || ""
					).trim() || undefined
				}
				feeSmall={feeSmall}
				setFeeSmall={setFeeSmall}
				feeMedium={feeMedium}
				setFeeMedium={setFeeMedium}
				feeLarge={feeLarge}
				setFeeLarge={setFeeLarge}
				imageSmall={imageSmall}
				setImageSmall={setImageSmall}
				imageMedium={imageMedium}
				setImageMedium={setImageMedium}
				imageLarge={imageLarge}
				setImageLarge={setImageLarge}
				stationShowMeetTab={stationShowMeetTab}
				setStationShowMeetTab={setStationShowMeetTab}
				stationShowNearbyTab={stationShowNearbyTab}
				setStationShowNearbyTab={setStationShowNearbyTab}
				mapImage={mapImage}
				setMapImage={setMapImage}
				meetStationSubtitle={meetStationSubtitle}
				setMeetStationSubtitle={setMeetStationSubtitle}
				nearbyAttractionsContent={nearbyAttractionsContent}
				setNearbyAttractionsContent={setNearbyAttractionsContent}
			/>
			)}
		</DialogWrapMedium>
	);
}

/** Toạ độ coi là có khi khác rỗng và khác 0 — khớp `hasPublishedCoordinates` ở backend. */
function coTriTrongToaDo(v?: string): boolean {
	const n = parseFloat(String(v ?? "").trim());
	return Number.isFinite(n) && n !== 0;
}

const canhBaoGoKhoiWeb: React.CSSProperties = {
	display: "flex",
	gap: 8,
	alignItems: "flex-start",
	marginTop: 10,
	padding: "9px 12px",
	borderRadius: 7,
	background: "#FBF1DF",
	border: "1px solid #E7D2A8",
	color: "#8A5408",
	fontSize: 12.5,
	fontWeight: 600,
	lineHeight: 1.5,
};

export function InputPartnerAdmin(props: {
	name: string;
	setName: (val: string) => void;
	address: string;
	setAddress: (val: string) => void;
	addressText: string;
	setAddressText: (val: string) => void;
	note: string;
	setNote: (val: string) => void;
	lat: string;
	setLat: (val: string) => void;
	long: string;
	setLong: (val: string) => void;
	displayName: string;
	setDisplayName: (val: string) => void;
	displayAddress: string;
	setDisplayAddress: (val: string) => void;
	toWork: string;
	setToWork: (val: string) => void;
	fromWork: string;
	setFromWork: (val: string) => void;
	price: string;
	setPrice: (val: string) => void;
	reviewScore: string;
	setReviewScore: (val: string) => void;
	reviewQuantity: string;
	setReviewQuantity: (val: string) => void;
	locationId: string;
	setLocationId: (val: string) => void;
	insurancePrice: string;
	setInsurancePrice: (val: string) => void;
	hotline: string[];
	setHotline: (val: string[]) => void;
	emailPartner: string;
	setEmailPartner: (val: string) => void;
	stationEmail: string;
	setStationEmail: (val: string) => void;
	stationCom?: string;
	setStationCom?: (val: string) => void;
	minimumPayout?: string;
	setMinimumPayout?: (val: string) => void;
	maximumPayout?: string;
	setMaximumPayout?: (val: string) => void;
	pubRate?: string;
	setPubRate?: (val: string) => void;
	rateLimitMax?: string;
	setRateLimitMax?: (val: string) => void;
	selectedCountryCode?: string;
	countryRatesRows?: any[];
	selectedLocation?: any | null;
	setSelectedLocation?: (val: any | null) => void;
	localCurrencyCode?: string;
	priceCompositionError?: string;
	estimatedPubRate?: number | null;
	destinationSelectRef?:
		| React.RefObject<PartnerDestinationSelectHandle | null>
		| React.MutableRefObject<PartnerDestinationSelectHandle | null>;
	closureDateRanges?: ClosureDateRangeRow[];
	setClosureDateRanges?: React.Dispatch<React.SetStateAction<ClosureDateRangeRow[]>>;
	permanentClosureEnabled?: boolean;
	setPermanentClosureEnabled?: (v: boolean) => void;
	permanentEffectiveFrom?: string;
	setPermanentEffectiveFrom?: (v: string) => void;
	closureConfigError?: string;
	stationTimezoneHint?: string;
	feeSmall?: string;
	setFeeSmall?: (val: string) => void;
	feeMedium?: string;
	setFeeMedium?: (val: string) => void;
	feeLarge?: string;
	setFeeLarge?: (val: string) => void;
	imageSmall?: string | null;
	setImageSmall?: (val: string | null) => void;
	imageMedium?: string | null;
	setImageMedium?: (val: string | null) => void;
	imageLarge?: string | null;
	setImageLarge?: (val: string | null) => void;
	// Station page content
	stationShowMeetTab?: boolean;
	setStationShowMeetTab?: (val: boolean) => void;
	stationShowNearbyTab?: boolean;
	setStationShowNearbyTab?: (val: boolean) => void;
	mapImage?: string;
	setMapImage?: (val: string) => void;
	meetStationSubtitle?: string;
	setMeetStationSubtitle?: (val: string) => void;
	nearbyAttractionsContent?: NearbyAttractionDraft[];
	setNearbyAttractionsContent?: (val: NearbyAttractionDraft[]) => void;
}) {
	const [bagImageUploading, setBagImageUploading] = React.useState<{
		small: boolean;
		medium: boolean;
		large: boolean;
	}>({
		small: false,
		medium: false,
		large: false,
	});

	const handleBagImageChange = async (
		sizeKey: "small" | "medium" | "large",
		file: File,
		setImage?: (val: string | null) => void
	) => {
		if (!setImage) return;
		setBagImageUploading((prev) => ({ ...prev, [sizeKey]: true }));
		try {
			const url = await uploadBagProductImage(file);
			setImage(url);
		} catch (err: any) {
			alert(err?.response?.data?.message || err?.message || "Upload anh that bai. Vui long thu lai.");
		} finally {
			setBagImageUploading((prev) => ({ ...prev, [sizeKey]: false }));
		}
	};

	// ── Một thang đo duy nhất cho cả form (bản gọn, 28/08) ───────────────────
	// Trước đây mỗi khối tự đặt cỡ chữ và khoảng cách: nhãn 12px CHỮ HOA to gần
	// bằng tiêu đề nhóm 14px, ô nhập 56px cao hơn cả hai. Mắt không biết bám vào
	// đâu. Nay: tiêu đề 13 → nhãn 11 → giá trị 13, và nhịp dọc chỉ có 12px.
	const gon = docCheDoGon();
	// Khối "Date-based closures" chỉ 8/302 station dùng (2,6% — đo prod 28/08). Gấp lại
	// theo mặc định, nhưng TỰ MỞ khi trạm này thực sự có ngày đóng: người đang sửa đúng
	// trạm đó không phải đi tìm.
	const soNgayDongCua =
		(props.closureDateRanges || []).length + (props.permanentClosureEnabled ? 1 : 0);
	const [moDongCua, setMoDongCua] = React.useState(false);
	React.useEffect(() => {
		if (soNgayDongCua > 0) setMoDongCua(true);
	}, [soNgayDongCua]);
	const sectionStyle: React.CSSProperties = {
		background: "#F9FAFB",
		border: "1px solid #E5E7EB",
		borderRadius: 10,
		padding: gon ? "13px 14px" : "14px 16px",
		marginBottom: gon ? 12 : 16,
	};
	const sectionTitleStyle: React.CSSProperties = {
		fontWeight: 700,
		fontSize: gon ? 13 : 14,
		marginBottom: gon ? 11 : 12,
		display: "flex",
		alignItems: "center",
		gap: 6,
		color: "#1F2937",
	};
	const labelStyle: React.CSSProperties = {
		fontWeight: 600,
		fontSize: gon ? 11 : 12,
		// Chữ hoa toàn bộ đọc chậm hơn hẳn khi có dấu tiếng Việt lẫn tiếng Anh, và
		// nhãn tô đậm cùng cỡ với giá trị thì hai thứ tranh nhau. Bản gọn hạ nhãn
		// xuống một bậc và làm nhạt màu.
		color: gon ? "#78909c" : "#374151",
		marginBottom: gon ? 4 : 3,
		textTransform: gon ? ("none" as const) : ("uppercase" as const),
		letterSpacing: gon ? "0" : "0.03em",
	};
	const gridRow: React.CSSProperties = {
		display: "grid",
		gridTemplateColumns: "1fr 1fr",
		gap: 12,
		marginBottom: gon ? 12 : 10,
	};

	const pricingPreview = React.useMemo(
		() =>
			buildPartnerPricingPreview({
				countryRatesRows: props.countryRatesRows,
				address: props.address,
				addressText: props.addressText,
				selectedCountryCode: props.selectedCountryCode,
				destinationCountry: props.selectedLocation?.country,
				localCurrencyCode: props.localCurrencyCode,
				manualStationCom: props.stationCom,
				manualMinimumPayout: props.minimumPayout,
			}),
		[
			props.address,
			props.addressText,
			props.countryRatesRows,
			props.localCurrencyCode,
			props.minimumPayout,
			props.selectedCountryCode,
			props.selectedLocation?.country,
			props.stationCom,
		]
	);

	const formatNum = (v: number | null) =>
		v === null
			? "—"
			: new Intl.NumberFormat("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 8,
			  }).format(v);
	const hasStationComOverride = (parseMoneyToNumber(props.stationCom || "") || 0) > 0;
	const hasMinimumPayoutOverride = (parseMoneyToNumber(props.minimumPayout || "") || 0) > 0;
	const moneySuffix = pricingPreview.detectedCurrency?.code ? ` ${pricingPreview.detectedCurrency.code}` : "";
	const stationComAppliedText =
		pricingPreview.appliedStationCom !== null
			? `${hasStationComOverride ? "Override" : "Country Rates"}: ${formatNum(
					pricingPreview.appliedStationCom
			  )}${moneySuffix}`
			: null;
	const minPayoutAppliedText =
		pricingPreview.appliedMinimumPayoutLocal !== null
			? hasMinimumPayoutOverride &&
			  pricingPreview.appliedMinimumPayoutUsd &&
			  pricingPreview.detectedCurrency?.code &&
			  pricingPreview.detectedCurrency.code !== "USD"
				? `${formatNum(pricingPreview.appliedMinimumPayoutUsd)} USD -> ${formatNum(
						pricingPreview.appliedMinimumPayoutLocal
				  )} ${pricingPreview.detectedCurrency.code}`
				: `${hasMinimumPayoutOverride ? "Thực tế" : "Country Rates"}: ${formatNum(
						pricingPreview.appliedMinimumPayoutLocal
				  )}${moneySuffix || " USD"}`
			: null;
	const appliedPillStyle: React.CSSProperties = {
		display: "inline-flex",
		alignItems: "center",
		padding: "4px 8px",
		borderRadius: 999,
		background: "#EFF6FF",
		border: "1px solid #BFDBFE",
		color: "#1D4ED8",
		fontSize: 10,
		fontWeight: 600,
		whiteSpace: "nowrap",
	};

	return (
		<div className={docCheDoGon() ? "wl-edit-gon" : undefined} style={{ display: "flex", flexDirection: "column", gap: 0 }}>
			{/* ── HỆ THỐNG THỊ GIÁC cho form Edit (28/08) ──────────────────────────
			     Ô nhập ở đây là `FomrmLoginInput` — component của TRANG ĐĂNG NHẬP:
			     cao 56px, chữ 16px, margin-bottom 16px. Một màn đăng nhập có 2 ô thì
			     đẹp; form này có hơn 40 ô nên nó kéo dài lê thê, chữ to hơn cả tiêu đề
			     nhóm, và khoảng cách thì mỗi chỗ một kiểu.

			     Sửa bằng một bộ quy tắc DUY NHẤT, bó trong `.wl-edit-gon` nên không
			     đụng tới trang đăng nhập hay bất kỳ màn nào khác:
			       · ô nhập  36px · chữ 13px
			       · nhãn    11px · xám · giãn chữ nhẹ
			       · nhịp    12px giữa các hàng, 14px trong khối
			     Tắt công tắc bản gọn là mọi thứ trở lại y như cũ. */}
			{docCheDoGon() ? (
				<style>{`
					.wl-edit-gon input,
					.wl-edit-gon select,
					.wl-edit-gon textarea {
						height: 36px;
						min-height: 36px;
						font-size: 13px;
						line-height: 20px;
						padding: 0 10px;
						margin-bottom: 0;
						border-radius: 7px;
					}
					.wl-edit-gon textarea { height: auto; min-height: 64px; padding: 8px 10px; }
					.wl-edit-gon input[type="checkbox"] { height: 15px; min-height: 15px; width: 15px; }
					.wl-edit-gon input::placeholder,
					.wl-edit-gon textarea::placeholder { font-size: 13px; color: #b0bcc6; }
					/* Nhãn: chữ hoa cỡ 12 đọc mệt trên form dài — hạ xuống 11 và làm nhạt
					   để mắt bám vào GIÁ TRỊ, không bám vào nhãn. */
					.wl-edit-gon label > div:first-child,
					.wl-edit-gon .wl-label { font-size: 11px !important; color: #78909c !important; }
					.wl-edit-gon > div > div { margin-bottom: 0; }

					/* Country / City dựng bằng Material-UI TextField outlined — mặc định
					   cao 56px, bo 4px, nhãn nổi cỡ 16. Đứng cạnh 40 ô 36px thì nó thô
					   hẳn ra. Kéo về đúng thang đo chung, chỉ trong hộp này. */
					.wl-edit-gon .MuiOutlinedInput-root {
						height: 36px;
						font-size: 13px;
						border-radius: 7px;
						background: #fff;
					}
					.wl-edit-gon .MuiOutlinedInput-input,
					.wl-edit-gon .MuiAutocomplete-input {
						height: 36px;
						box-sizing: border-box;
						padding: 0 10px !important;
						font-size: 13px;
					}
					.wl-edit-gon .MuiInputLabel-outlined {
						font-size: 13px;
						transform: translate(11px, 10px) scale(1);
					}
					.wl-edit-gon .MuiInputLabel-outlined.MuiInputLabel-shrink {
						transform: translate(11px, -7px) scale(0.82);
					}
					.wl-edit-gon .MuiOutlinedInput-notchedOutline { border-color: #dfe4e8; }
					.wl-edit-gon .MuiAutocomplete-endAdornment { top: calc(50% - 13px); }
					.wl-edit-gon .MuiFormControl-root { margin-bottom: 0; }
				`}</style>
			) : null}
			{/* ── VÒNG 5 (CGO ↔ COO) ───────────────────────────────────────────────
			     CGO: cắt 3 khối 0-dùng là đúng nhưng form vẫn sáu nhóm dọc, cuộn mỏi.
			     COO: đổi sang tab là đổi thói quen của người dùng nó hằng ngày — rủi ro
			     cao hơn cái lợi.
			     ⇒ Giữ nguyên sáu nhóm, thêm MỤC LỤC DÍNH ở đầu: nhảy thẳng tới nhóm cần,
			       không ai phải học lại gì. */}
			{docCheDoGon() ? (
				<div
					style={{
						position: "sticky",
						top: 0,
						zIndex: 3,
						display: "flex",
						flexWrap: "wrap",
						gap: 0,
						padding: "2px 0 0",
						marginBottom: 12,
						background: "#fff",
						borderBottom: "1px solid #eceff1",
					}}>
					{[
						["kh-cb", "Basic"],
						["kh-dc", "Address"],
						["kh-gio", "Hours"],
						["kh-gia", "Pricing"],
						["kh-tc", "Finance"],
						["kh-dg", "Reviews"],
					].map(([idn, chu]) => (
						<button
							key={idn}
							type="button"
							onClick={() => document.getElementById(idn)?.scrollIntoView({ behavior: "smooth", block: "start" })}
							style={{
								padding: "7px 2px",
								margin: "0 14px 0 0",
								border: "none",
								borderBottom: "2px solid transparent",
								background: "none",
								color: "#78909c",
								fontSize: 12.5,
								fontWeight: 600,
								cursor: "pointer",
							}}
							onMouseEnter={(e) => {
								e.currentTarget.style.color = "#1a237e";
								e.currentTarget.style.borderBottomColor = "#c5cae9";
							}}
							onMouseLeave={(e) => {
								e.currentTarget.style.color = "#78909c";
								e.currentTarget.style.borderBottomColor = "transparent";
							}}>
							{chu}
						</button>
					))}
				</div>
			) : null}
			{/* ═══ Group 1: Thông tin cơ bản ═══ */}
			<div style={sectionStyle}>
				<div id="kh-cb" style={sectionTitleStyle}>Basic information</div>

				<div style={gridRow}>
					<div>
						<div style={labelStyle}>Station name</div>
						<FomrmLoginInput
							placeholder="Station name"
							value={props.name}
							onChange={(e) => props.setName(e.target.value)}
						/>
					</div>
					<div>
						<div style={labelStyle}>Email Station</div>
						<FomrmLoginInput
							placeholder="station@example.com"
							value={props.stationEmail}
							onChange={(e) => props.setStationEmail(e.target.value)}
						/>
					</div>
				</div>

				<div style={{ marginBottom: 10 }}>
					{/* 08/10 (từ vựng Single/Chain): ô này gán station vào Store của một chủ chuỗi. */}
					<div style={labelStyle}>Chain owner email</div>
					<AdminFilterEmailPartner
						all={true}
						filterStaffId={props.emailPartner}
						doChangeStaffId={props.setEmailPartner}
					/>
				</div>

				<div style={{ marginBottom: 0 }}>
					<div style={labelStyle}>Location / Destination</div>
					<PartnerDestinationSelect
						ref={props.destinationSelectRef as React.Ref<PartnerDestinationSelectHandle>}
						mode="worldLibraryAndCreate"
						extraDestinations={
							props.selectedLocation?.id != null
								? [
										{
											id: String(props.selectedLocation.id),
											name: String(props.selectedLocation.name ?? ""),
											country: props.selectedLocation.country ?? null,
										},
								  ]
								: []
						}
						destinationId={props.locationId}
						setDestinationId={props.setLocationId}
						setSelectedLocation={(loc) => props.setSelectedLocation?.(loc)}
					/>
				</div>
			</div>

			{/* ═══ Group 2: Địa chỉ & Vị trí ═══ */}
			<div style={sectionStyle}>
				<div id="kh-dc" style={sectionTitleStyle}>Address &amp; location</div>
				<div style={gridRow}>
					<div>
						<div style={labelStyle}>Google Maps link</div>
						<FomrmLoginInput
							placeholder="https://maps.app.goo.gl/… or maps.google.com/?q=…"
							value={props.address}
							onChange={(e) => props.setAddress(e.target.value)}
						/>
					</div>
					<div>
						<div style={labelStyle}>Address Text</div>
						<FomrmLoginInput
							placeholder="Address text"
							value={props.addressText}
							onChange={(e) => props.setAddressText(e.target.value)}
						/>
					</div>
				</div>
				<div style={gridRow}>
					<div>
						<div style={labelStyle}>Display Name</div>
						<FomrmLoginInput
							placeholder="Display name"
							value={props.displayName}
							onChange={(e) => props.setDisplayName(e.target.value)}
						/>
					</div>
					<div>
						<div style={labelStyle}>Display Address</div>
						<FomrmLoginInput
							placeholder="Display address"
							value={props.displayAddress}
							onChange={(e) => props.setDisplayAddress(e.target.value)}
						/>
					</div>
				</div>
				<div style={gridRow}>
					<div>
						<div style={labelStyle}>Latitude</div>
						<FomrmLoginInput
							placeholder="Latitude"
							value={props.lat}
							onChange={(e) => props.setLat(e.target.value)}
						/>
					</div>
					<div>
						<div style={labelStyle}>Longitude</div>
						<FomrmLoginInput
							placeholder="Longitude"
							value={props.long}
							onChange={(e) => props.setLong(e.target.value)}
						/>
					</div>
				</div>
				{/* Xoá toạ độ = gỡ station khỏi bản đồ NGAY. Đây là một trong hai đường đổi
				    trạng thái ngầm rà ra 25/08 — người sửa toạ độ không hề biết mình vừa tắt
				    station. Cảnh báo tại chỗ, không chặn lưu (Quân chốt 25/08, phương án A). */}
				{!coTriTrongToaDo(props.lat) || !coTriTrongToaDo(props.long) ? (
					<div style={canhBaoGoKhoiWeb}>
						<span aria-hidden="true">⚠️</span>
						<span>
							Without both coordinates this station cannot appear on the map — status becomes{" "}
							<b>Actived</b> and it stops taking bookings.
						</span>
					</div>
				) : null}
			</div>

			{/* ═══ Group 3: Giờ hoạt động ═══ */}
			<div style={sectionStyle}>
				<div id="kh-gio" style={sectionTitleStyle}>Opening hours</div>

				<div style={{ ...labelStyle, textTransform: "none", marginBottom: 8, color: "#374151" }}>
					Front desk hours (same as the station sign-up form)
				</div>
				{/* Tuỳ chọn 24h (Quân 17/09: màn cũ thiếu nút chọn 24h). Tick = set 00:00-23:59. */}
				<label
					style={{
						display: "flex",
						alignItems: "center",
						gap: 8,
						marginBottom: 10,
						cursor: "pointer",
						fontSize: 13,
						color: "#374151",
					}}>
					<input
						type="checkbox"
						checked={props.fromWork === "00:00" && props.toWork === "23:59"}
						onChange={(e) => {
							if (e.target.checked) {
								props.setFromWork("00:00");
								props.setToWork("23:59");
							} else {
								props.setFromWork("");
								props.setToWork("");
							}
						}}
					/>
					Open 24 hours (all day)
				</label>
				<div style={gridRow}>
					<div>
						<div style={labelStyle}>Opens at</div>
						{/* Ô chọn giờ (HH:MM) thay ô gõ chữ — Quân chốt 26/10/2026. */}
						<input
							type="time"
							step={900}
							value={props.fromWork}
							onChange={(e) => props.setFromWork(e.target.value)}
							style={{ width: "100%", height: 44, padding: "0 12px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 15, boxSizing: "border-box" }}
						/>
					</div>
					<div>
						<div style={labelStyle}>Closes at</div>
						{/* Ô chọn giờ (HH:MM) thay ô gõ chữ — Quân chốt 26/10/2026. */}
						<input
							type="time"
							step={900}
							value={props.toWork}
							onChange={(e) => props.setToWork(e.target.value)}
							style={{ width: "100%", height: 44, padding: "0 12px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 15, boxSizing: "border-box" }}
						/>
					</div>
				</div>

				{props.setClosureDateRanges ? (
					<div
						style={{
							marginTop: 12,
							padding: "12px 14px",
							background: "#FFFBEB",
							border: "1px solid #FDE68A",
							borderRadius: 8,
						}}>
						<div
							style={{
								fontWeight: 700,
								fontSize: 12,
								color: "#92400E",
								marginBottom: 8,
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								gap: 8,
								flexWrap: "wrap",
							}}>
							<span>
								<button
									type="button"
									onClick={() => setMoDongCua((v) => !v)}
									style={{
										border: "none",
										background: "none",
										padding: 0,
										font: "inherit",
										color: "inherit",
										cursor: "pointer",
									}}>
									{moDongCua ? "▾" : "▸"} Date-based closures
									{!moDongCua && soNgayDongCua > 0 ? ` · ${soNgayDongCua} in use` : ""}
								</button>
							</span>
							{props.stationTimezoneHint ? (
								<span style={{ fontWeight: 500, fontSize: 10, color: "#B45309" }}>
									Station timezone: {props.stationTimezoneHint}
								</span>
							) : null}
						</div>
						<div
							style={{
								display: moDongCua ? undefined : "none",
								fontSize: 11,
								color: "#78350F",
								marginBottom: 10,
								lineHeight: 1.45,
							}}>
							Dates inside a range, or on/after the permanent closure date, count as closed all day — including days
							already closed by the weekly schedule.
						</div>
						<div style={{ display: moDongCua ? undefined : "none" }}>

						{(props.closureDateRanges || []).map((row, idx) => (
							<div
								key={idx}
								style={{
									display: "grid",
									gridTemplateColumns: "1fr 1fr auto",
									gap: 8,
									alignItems: "end",
									marginBottom: 8,
								}}>
								<div>
									<div style={{ ...labelStyle, textTransform: "none" }}>From</div>
									<input
										type="date"
										value={row.from}
										onChange={(e) => {
											const next = [...(props.closureDateRanges || [])];
											next[idx] = { ...next[idx], from: e.target.value };
											props.setClosureDateRanges?.(next);
										}}
										style={{
											width: "100%",
											boxSizing: "border-box",
											padding: "9px 10px",
											borderRadius: 6,
											border: "1px solid #E5E7EB",
											fontSize: 14,
										}}
									/>
								</div>
								<div>
									<div style={{ ...labelStyle, textTransform: "none" }}>To</div>
									<input
										type="date"
										value={row.to}
										onChange={(e) => {
											const next = [...(props.closureDateRanges || [])];
											next[idx] = { ...next[idx], to: e.target.value };
											props.setClosureDateRanges?.(next);
										}}
										style={{
											width: "100%",
											boxSizing: "border-box",
											padding: "9px 10px",
											borderRadius: 6,
											border: "1px solid #E5E7EB",
											fontSize: 14,
										}}
									/>
								</div>
								<button
									type="button"
									onClick={() => {
										const next = (props.closureDateRanges || []).filter((_, i) => i !== idx);
										props.setClosureDateRanges?.(next);
									}}
									style={{
										padding: "8px 10px",
										fontSize: 12,
										fontWeight: 600,
										color: "#B45309",
										background: "#FEF3C7",
										border: "1px solid #FCD34D",
										borderRadius: 6,
										cursor: "pointer",
									}}>
									Xóa
								</button>
							</div>
						))}

						<button
							type="button"
							onClick={() => props.setClosureDateRanges?.((prev) => [...prev, { from: "", to: "" }])}
							style={{
								marginBottom: 12,
								padding: "6px 12px",
								fontSize: 12,
								fontWeight: 600,
								color: "#92400E",
								background: "#FEF3C7",
								border: "1px solid #FCD34D",
								borderRadius: 6,
								cursor: "pointer",
							}}>
							+ Add date range
						</button>

						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: 10,
								flexWrap: "wrap",
								marginBottom: 8,
							}}>
							<label
								style={{
									display: "flex",
									alignItems: "center",
									gap: 8,
									cursor: "pointer",
									fontSize: 13,
									fontWeight: 600,
									color: "#78350F",
								}}>
								<input
									type="checkbox"
									checked={Boolean(props.permanentClosureEnabled)}
									onChange={(e) => props.setPermanentClosureEnabled?.(e.target.checked)}
								/>
								Permanent closure (from a date onwards)
							</label>
						</div>
						{/* Rà 25/08: bật ô này là station biến khỏi web NGAY khi tới ngày hiệu lực,
						    mà trước giờ màn hình không nói một câu nào — và KHÔNG bảng log nào ghi lại
						    ai bật. Quân chốt 25/08 phương án A: cảnh báo tại chỗ, không chặn luồng lưu. */}
						{props.permanentClosureEnabled ? (
							<div style={canhBaoGoKhoiWeb}>
								<span aria-hidden="true">⚠️</span>
								<span>
									This removes the station from the website from the date below — status becomes{" "}
									<b>Actived</b> and it stops taking bookings. Nothing is logged, so note the reason
									somewhere the next person can find it.
								</span>
							</div>
						) : null}
						{props.permanentClosureEnabled ? (
							<div style={{ maxWidth: 280 }}>
								<div style={{ ...labelStyle, textTransform: "none" }}>Effective from</div>
								<input
									type="date"
									value={props.permanentEffectiveFrom || ""}
									onChange={(e) => props.setPermanentEffectiveFrom?.(e.target.value)}
									style={{
										width: "100%",
										boxSizing: "border-box",
										padding: "9px 10px",
										borderRadius: 6,
										border: "1px solid #E5E7EB",
										fontSize: 14,
									}}
								/>
							</div>
						) : null}
						{props.closureConfigError ? (
							<div style={{ color: "#DC2626", fontSize: 12, marginTop: 8, fontWeight: 600 }}>
								{props.closureConfigError}
							</div>
						) : null}
						</div>
					</div>
				) : null}
			</div>

			{/* ═══ Group 4: Bảng giá ═══ */}
			<div style={sectionStyle}>
				<div id="kh-gia" style={sectionTitleStyle}>Pricing</div>

				<div style={gridRow}>
					<div>
						<div style={labelStyle}>Base price</div>
						<FomrmLoginInput
							placeholder="50,000.00"
							value={props.price}
							onChange={(e) =>
								props.setPrice(formatMoneyInputDisplay(sanitizeMoneyInput(e.target.value, props.price)))
							}
						/>
					</div>
					<div>
						<div style={labelStyle}>Insurance Price</div>
						<FomrmLoginInput
							placeholder="1,500.50"
							value={props.insurancePrice}
							onChange={(e) =>
								props.setInsurancePrice(
									formatMoneyInputDisplay(sanitizeMoneyInput(e.target.value, props.insurancePrice))
								)
							}
						/>
					</div>
				</div>
				<div style={gridRow}>
					<div>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								gap: 8,
								marginBottom: 3,
							}}>
							<div style={labelStyle}>Public Rate</div>
							{props.estimatedPubRate != null ? (
								<div style={appliedPillStyle}>
									Country Rates: {formatValueToDisplay(props.estimatedPubRate)}
								</div>
							) : null}
						</div>
						<FomrmLoginInput
							placeholder={
								props.estimatedPubRate != null
									? `Default: ${formatValueToDisplay(props.estimatedPubRate)}`
									: "VD: 4,75"
							}
							type="text"
							inputMode="decimal"
							value={props.pubRate ?? ""}
							onChange={(e) =>
								props.setPubRate?.(
									formatMoneyInputDisplay(sanitizeMoneyInput(e.target.value, props.pubRate || ""))
								)
							}
						/>
						{props.priceCompositionError ? (
							<div style={{ color: "#DC2626", fontSize: 11, marginTop: 6, fontWeight: 600 }}>
								{props.priceCompositionError}
							</div>
						) : null}
					</div>
					<div />
				</div>

				{/* Giá theo kích thước hành lý: feeSmall/feeMedium/feeLarge (để trống ⇒ fee × 0.7/1.0/1.3).
				    13/10/2026 Quân chốt giá 3 cỡ túi ⇒ hiện cả ở bản gọn. */}
				<div>
				<div style={{ borderTop: "1px solid #E5E7EB", margin: "12px 0 10px" }} />
				<div style={{ ...labelStyle, marginBottom: 10 }}>Price by luggage size</div>
				<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
					{(
						[
							{
								sizeKey: "small" as const,
								label: "Small bag",
								hint: "≤30L · 0.7x giá cơ bản",
								fee: props.feeSmall ?? "",
								setFee: props.setFeeSmall,
								image: props.imageSmall ?? null,
								setImage: props.setImageSmall,
							},
							{
								sizeKey: "medium" as const,
								label: "Standard suitcase",
								hint: "≤55cm · 1.0x giá cơ bản",
								fee: props.feeMedium ?? "",
								setFee: props.setFeeMedium,
								image: props.imageMedium ?? null,
								setImage: props.setImageMedium,
							},
							{
								sizeKey: "large" as const,
								label: "Oversized",
								hint: "≤76x48x32cm · 1.3x giá cơ bản",
								fee: props.feeLarge ?? "",
								setFee: props.setFeeLarge,
								image: props.imageLarge ?? null,
								setImage: props.setImageLarge,
							},
						] as {
							sizeKey: "small" | "medium" | "large";
							label: string;
							hint: string;
							fee: string;
							setFee?: (v: string) => void;
							image: string | null;
							setImage?: (v: string | null) => void;
						}[]
					).map((col) => {
						const isUploading = bagImageUploading[col.sizeKey];
						return (
							<div key={col.label}>
								<div style={labelStyle}>{col.label}</div>
								<div style={{ fontSize: 10, color: "#6B7280", marginBottom: 6 }}>{col.hint}</div>
								<FomrmLoginInput
									placeholder="50,000.00"
									type="text"
									inputMode="decimal"
									value={col.fee}
									onChange={(e) =>
										col.setFee?.(
											formatMoneyInputDisplay(sanitizeMoneyInput(e.target.value, col.fee))
										)
									}
								/>
								<div style={{ marginTop: 8 }}>
									{isUploading ? (
										<div
											style={{
												width: 64,
												height: 64,
												background: "#EFF6FF",
												border: "1px solid #BFDBFE",
												borderRadius: 6,
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												fontSize: 10,
												color: "#1D4ED8",
												marginBottom: 6,
											}}>
											Dang tai...
										</div>
									) : col.image ? (
										<img
											src={col.image}
											alt={col.label}
											style={{
												width: 64,
												height: 64,
												objectFit: "cover",
												borderRadius: 6,
												display: "block",
												marginBottom: 6,
											}}
										/>
									) : (
										<div
											style={{
												width: 64,
												height: 64,
												background: "#F3F4F6",
												border: "1px dashed #D1D5DB",
												borderRadius: 6,
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												fontSize: 10,
												color: "#9CA3AF",
												marginBottom: 6,
											}}>
											No img
										</div>
									)}
									<label
										style={{
											cursor: isUploading ? "not-allowed" : "pointer",
											fontSize: 11,
											color: isUploading ? "#9CA3AF" : "#1D4ED8",
											display: "inline-block",
										}}>
										{isUploading ? "Dang tai len..." : "Chon anh"}
										<input
											type="file"
											accept="image/*"
											disabled={isUploading}
											style={{ display: "none" }}
											onChange={(e) => {
												const file = e.target.files?.[0];
												if (!file || isUploading) return;
												void handleBagImageChange(col.sizeKey, file, col.setImage);
												// Reset input so same file can be re-selected after a removal
												e.target.value = "";
											}}
										/>
									</label>
									{col.image ? (
										<button
											type="button"
											onClick={() => col.setImage?.(null)}
											style={{
												marginLeft: 8,
												fontSize: 11,
												color: "#DC2626",
												background: "none",
												border: "none",
												cursor: "pointer",
												padding: 0,
											}}>
											Xóa
										</button>
									) : null}
								</div>
							</div>
						);
					})}
				</div>
				</div>
			</div>

			{/* ═══ Group 5: Tài chính ═══ */}
			<div style={{ ...sectionStyle, background: "#F0F9FF", border: "1px solid #BAE6FD" }}>
				<div id="kh-tc" style={{ ...sectionTitleStyle, color: "#0369A1" }}>Finance</div>

				<div style={{ color: "#6B7280", fontSize: 11, marginBottom: 12, fontStyle: "italic" }}>
					Leave empty to use the country rate.
				</div>

				<div style={{ display: "flex", gap: 10, marginBottom: 12, flexWrap: "wrap" }}>
					{pricingPreview.detectedCountry ? (
						<div
							style={{
								display: "inline-flex",
								alignItems: "center",
								gap: 6,
								background: "#ECFDF5",
								border: "1px solid #A7F3D0",
								borderRadius: 8,
								padding: "5px 12px",
								fontSize: 12,
								color: "#065F46",
							}}>
							🌍 <strong>{pricingPreview.detectedCountry}</strong>
						</div>
					) : (
						<div
							style={{
								display: "inline-flex",
								alignItems: "center",
								gap: 6,
								background: "#FEF3C7",
								border: "1px solid #FDE68A",
								borderRadius: 8,
								padding: "5px 12px",
								fontSize: 11,
								color: "#92400E",
							}}>
							⚠️ Chưa nhận diện quốc gia
						</div>
					)}
					{pricingPreview.detectedCurrency ? (
						<div
							style={{
								display: "inline-flex",
								alignItems: "center",
								gap: 6,
								background: "#EDE9FE",
								border: "1px solid #C4B5FD",
								borderRadius: 8,
								padding: "5px 12px",
								fontSize: 12,
								color: "#5B21B6",
							}}>
							💱 <strong>{pricingPreview.detectedCurrency.code}</strong>
							{pricingPreview.detectedCurrency.name ? (
								<span style={{ fontWeight: 400, color: "#7C3AED" }}>
									({pricingPreview.detectedCurrency.name})
								</span>
							) : null}
						</div>
					) : null}
				</div>

				<div style={gridRow}>
					<div>
						<div style={labelStyle}>
							<span style={{ color: "#065F46" }}>EST STT Com</span>
							<span style={{ fontWeight: 400, color: "#9CA3AF", fontSize: 10, marginLeft: 4 }}>
								(estimated)
							</span>
						</div>
						<div
							style={{
								background: pricingPreview.detectedCountry ? "#D1FAE5" : "#F3F4F6",
								border: `1px solid ${pricingPreview.detectedCountry ? "#6EE7B7" : "#E5E7EB"}`,
								borderRadius: 6,
								padding: "9px 10px",
								fontSize: 15,
								fontWeight: 700,
								color: pricingPreview.detectedCountry ? "#047857" : "#9CA3AF",
								minHeight: 40,
								display: "flex",
								alignItems: "center",
							}}>
							{formatNum(pricingPreview.estSttCom)}
						</div>
					</div>
					<div>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								gap: 8,
								marginBottom: 3,
							}}>
							<div style={labelStyle}>
								<span style={{ color: "#1E40AF" }}>STT Com</span>
								<span style={{ fontWeight: 400, color: "#9CA3AF", fontSize: 10, marginLeft: 4 }}>
									(manual)
								</span>
							</div>
							{stationComAppliedText ? <div style={appliedPillStyle}>{stationComAppliedText}</div> : null}
						</div>
						<FomrmLoginInput
							placeholder={
								pricingPreview.estSttCom
									? `Default: ${formatNum(pricingPreview.estSttCom)}`
									: "VD: 50,000.00"
							}
							type="text"
							inputMode="decimal"
							value={props.stationCom ?? ""}
							onChange={(e) =>
								props.setStationCom?.(
									formatMoneyInputDisplay(sanitizeMoneyInput(e.target.value, props.stationCom || ""))
								)
							}
						/>
					</div>
				</div>

				<div style={gridRow}>
					<div>
						<div style={labelStyle}>
							<span style={{ color: "#065F46" }}>Est Min Payout</span>
							<span style={{ fontWeight: 400, color: "#9CA3AF", fontSize: 10, marginLeft: 4 }}>
								(estimated)
							</span>
						</div>
						<div
							style={{
								background: pricingPreview.detectedCountry ? "#D1FAE5" : "#F3F4F6",
								border: `1px solid ${pricingPreview.detectedCountry ? "#6EE7B7" : "#E5E7EB"}`,
								borderRadius: 6,
								padding: "9px 10px",
								fontSize: 15,
								fontWeight: 700,
								color: pricingPreview.detectedCountry ? "#047857" : "#9CA3AF",
								minHeight: 40,
								display: "flex",
								alignItems: "center",
							}}>
							{formatNum(pricingPreview.estMinPayout)}
						</div>
					</div>
					<div>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								gap: 8,
								marginBottom: 3,
							}}>
							<div style={labelStyle}>
								<span style={{ color: "#1E40AF" }}>Min Payout</span>
								<span style={{ fontWeight: 400, color: "#9CA3AF", fontSize: 10, marginLeft: 4 }}>
									(manual)
								</span>
							</div>
							{minPayoutAppliedText ? <div style={appliedPillStyle}>{minPayoutAppliedText}</div> : null}
						</div>
						<FomrmLoginInput
							placeholder={
								pricingPreview.estMinPayout
									? `Default: ${formatNum(pricingPreview.estMinPayout)}`
									: "VD: 25.000"
							}
							type="text"
							inputMode="decimal"
							value={props.minimumPayout ?? ""}
							onChange={(e) =>
								props.setMinimumPayout?.(
									formatMoneyInputDisplay(
										sanitizeMoneyInput(e.target.value, props.minimumPayout || "")
									)
								)
							}
						/>
					</div>
				</div>

				{/* Maximum Payout và Rate Limit Max: 0/302 station có giá trị (đo prod 28/08).
				    Cả hàng là ô trống nên bản gọn bỏ đi. */}
				<div style={{ ...gridRow, display: docCheDoGon() ? "none" : gridRow.display }}>
					<div>
						<div style={labelStyle}>
							<span style={{ color: "#1E40AF" }}>Maximum Payout</span>
						</div>
						<FomrmLoginInput
							placeholder="1,000,000"
							type="text"
							inputMode="decimal"
							value={props.maximumPayout ?? ""}
							onChange={(e) =>
								props.setMaximumPayout?.(
									formatMoneyInputDisplay(
										sanitizeMoneyInput(e.target.value, props.maximumPayout || "")
									)
								)
							}
						/>
					</div>
					<div>
						<div style={labelStyle}>
							<span style={{ color: "#1E40AF" }}>Rate Limit Max</span>
						</div>
						<FomrmLoginInput
							placeholder="10"
							type="text"
							inputMode="decimal"
							value={props.rateLimitMax ?? ""}
							onChange={(e) =>
								props.setRateLimitMax?.(
									formatMoneyInputDisplay(
										sanitizeMoneyInput(e.target.value, props.rateLimitMax || "")
									)
								)
							}
						/>
					</div>
				</div>

				<div style={{ fontSize: 10, color: "#6B7280", marginTop: 4, fontStyle: "italic" }}>
					* Format: <b>,</b> thousands separator, <b>.</b> decimal separator. E.g. 50,000.00 or 1,500.75
				</div>
			</div>

			{/* ═══ Group 6: Đánh giá & Hotline ═══ */}
			<div style={sectionStyle}>
				<div id="kh-dg" style={sectionTitleStyle}>Reviews &amp; hotline</div>
				<div style={gridRow}>
					<div>
						<div style={labelStyle}>Review Score</div>
						<FomrmLoginInput
							placeholder="4.5"
							type="text"
							inputMode="decimal"
							value={props.reviewScore}
							onChange={(e) => {
								const v = e.target.value.replace(/[^0-9.]/g, "");
								props.setReviewScore(v);
							}}
						/>
					</div>
					<div>
						<div style={labelStyle}>Review Quantity</div>
						<FomrmLoginInput
							placeholder="120"
							type="text"
							inputMode="numeric"
							value={props.reviewQuantity}
							onChange={(e) => {
								const v = e.target.value.replace(/[^0-9]/g, "");
								props.setReviewQuantity(v);
							}}
						/>
					</div>
				</div>

				<div style={labelStyle}>Hotline</div>
				<div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 4, marginBottom: 10 }}>
					{props.hotline.map((val, index) => {
						// Bỏ ô "Customer support" (slot 2) khỏi màn Edit Station — đây là số
						// hỗ trợ cấp WhaleLO, không phải dữ liệu của từng station (Quân 16/09).
						// Giữ nguyên index để các slot khác vẫn ghi đúng vị trí.
						if (index === 2) return null;
						const hotlineLabel =
							index === 0
								? "Facility hotline 1"
								: index === 1
								? "Facility hotline 2"
								: index === 2
								? "Customer support"
								: "Station support";

						return (
							<div key={index}>
								<div style={{ ...labelStyle, marginBottom: 6, textTransform: "none" }}>
									{hotlineLabel}
								</div>
								<FomrmLoginInput
									placeholder={hotlineLabel}
									value={val}
									onChange={(e) => {
										const newHotlines = [...props.hotline];
										newHotlines[index] = e.target.value;
										props.setHotline(newHotlines);
									}}
								/>
							</div>
						);
					})}
				</div>

				<div style={labelStyle}>Internal note</div>
				<FomrmLoginInput
					placeholder="Internal note"
					value={props.note}
					onChange={(e) => props.setNote(e.target.value)}
				/>
			</div>
		</div>
	);
}

// --- Nearby Attractions inline editor for whalelo-admin ---
interface NearbyAttractionsAdminEditorProps {
	items: NearbyAttractionDraft[];
	onChange: (items: NearbyAttractionDraft[]) => void;
}

export function NearbyAttractionsAdminEditor({ items, onChange }: NearbyAttractionsAdminEditorProps) {
	const rowStyle: React.CSSProperties = {
		display: "grid",
		gridTemplateColumns: "100px 1fr 1fr auto",
		gap: 8,
		alignItems: "flex-start",
		marginBottom: 10,
	};
	const inputStyle: React.CSSProperties = {
		padding: "7px 10px",
		border: "1px solid #D1D5DB",
		borderRadius: 4,
		fontSize: 13,
		width: "100%",
		boxSizing: "border-box",
	};
	const colLabelStyle: React.CSSProperties = {
		fontSize: 11,
		color: "#6B7280",
		marginBottom: 3,
	};

	const handleAdd = () => {
		onChange([...items, { image: "", title: "", walkingMinutes: 5, description: "" }]);
	};

	const handleDelete = (index: number) => {
		onChange(items.filter((_, i) => i !== index));
	};

	const handleChange = (index: number, field: keyof NearbyAttractionDraft, value: string | number | File) => {
		const updated = items.map((item, i) => {
			if (i !== index) return item;
			if (field === "walkingMinutes") return { ...item, [field]: Number(value) || 0 };
			return { ...item, [field]: value };
		});
		onChange(updated);
	};

	return (
		<div style={{ marginTop: 6 }}>
			{items.length > 0 && (
				<div style={rowStyle}>
					<div style={colLabelStyle}>Image</div>
					<div style={colLabelStyle}>Overlay text (e.g. "5 mins to Hoan Kiem Lake")</div>
					<div style={colLabelStyle}>Description</div>
					<div />
				</div>
			)}
			{items.map((item, index) => (
				<div
					key={index}
					style={rowStyle}>
					<div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
						{item.image ? (
							<div style={{ position: "relative", width: 80, height: 60 }}>
								<img
									src={
										item.image instanceof File
											? URL.createObjectURL(item.image)
											: resolveAssetUrl(item.image)
									}
									alt="preview"
									style={{
										width: 80,
										height: 60,
										objectFit: "cover",
										borderRadius: 4,
										border: "1px solid #E5E7EB",
									}}
								/>
								<button
									type="button"
									onClick={() => handleChange(index, "image", "")}
									style={{
										position: "absolute",
										top: -6,
										right: -6,
										width: 18,
										height: 18,
										borderRadius: "50%",
										background: "#EF4444",
										color: "#fff",
										border: "none",
										cursor: "pointer",
										fontSize: 11,
										lineHeight: "18px",
										textAlign: "center",
										padding: 0,
									}}>
									×
								</button>
							</div>
						) : (
							<label style={{ cursor: "pointer" }}>
								<input
									type="file"
									accept="image/*"
									style={{ display: "none" }}
									onChange={(e) => {
										const file = e.target.files?.[0];
										if (file) handleChange(index, "image", file as any);
										e.target.value = "";
									}}
								/>
								<div
									style={{
										width: 80,
										height: 60,
										border: "2px dashed #D1D5DB",
										borderRadius: 4,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										justifyContent: "center",
										color: "#9CA3AF",
										fontSize: 11,
										gap: 2,
									}}>
									<span style={{ fontSize: 18 }}>+</span>
									<span>Upload</span>
								</div>
							</label>
						)}
					</div>
					<input
						style={inputStyle}
						placeholder="5 mins to Hoan Kiem Lake"
						value={item.title}
						onChange={(e) => handleChange(index, "title", e.target.value)}
					/>
					<input
						style={inputStyle}
						placeholder="Description"
						value={item.description}
						onChange={(e) => handleChange(index, "description", e.target.value)}
					/>
					<button
						type="button"
						onClick={() => handleDelete(index)}
						style={{
							padding: "6px 10px",
							background: "#FEE2E2",
							color: "#DC2626",
							border: "1px solid #FCA5A5",
							borderRadius: 4,
							fontSize: 12,
							cursor: "pointer",
							whiteSpace: "nowrap",
						}}>
						Xóa
					</button>
				</div>
			))}
			{items.length < 3 && (
				<button
					type="button"
					onClick={handleAdd}
					style={{
						marginTop: 4,
						padding: "7px 14px",
						background: "#DCFCE7",
						color: "#166534",
						border: "1px solid #86EFAC",
						borderRadius: 4,
						fontSize: 13,
						fontWeight: 600,
						cursor: "pointer",
					}}>
					+ Thêm điểm tham quan
				</button>
			)}
		</div>
	);
}
